import apiClient, { API_ENDPOINTS } from 'api';

const { bulkOrder } = API_ENDPOINTS;

const findBulkOrders = (criteria) => async () => apiClient.post(bulkOrder.findByCriteria, criteria);

export { findBulkOrders };
